<template>
    <div v-if="faults > 0">
        <div class="fault-label">
            {{ label }}
        </div>
        <div class="fault-count" :class="background">
            <span >{{ confirmed }}/{{faults}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "PIncAssessmentCardFaults",

    props: {
        type: {

        },

        faults: {

        },
        confirmed: {

        }
    },

    computed: {
        label () {
            return this.$t("todo.assessment.label." + this.type);
        },

        background () {
            if (this.faults === this.confirmed) {
                switch (this.type) {
                    case "minor":
                        return "primary-border";
                    case "middle":
                        return "warning-border warning--text";
                    case "major":
                        return "error-border error--text";
                }

                return;
            }

            switch (this.type) {
                case "minor":
                    return "primary primary-border";
                case "middle":
                    return "warning warning-border";
                case "major":
                    return "error error-border";
            }

            return null;
        }
    }
}
</script>

<style scoped>

.fault-label {
    font-size: 11px!important;
    width: 60px;
    text-align: center;
    margin-bottom: 2px;
    margin-top: -1px;
}

.fault-count {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-left: 15px;
    padding-left: 5px;
    padding-top: 4px;
    color: white;
    font-size: 13px;
}

</style>